module.exports = __webpack_public_path__ + "img/vote-signup-title@2x.a5673586.png";